"use strict";
/*
 * Created on 30/01/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var LocalisationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(LocalisationConverter, _DataObjectConverter_);

  function LocalisationConverter() {
    _classCallCheck(this, LocalisationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalisationConverter).apply(this, arguments));
  }

  return LocalisationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.LocalisationConverter = LocalisationConverter;